import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Box, Flex, Header, styled } from '@driftt/dds'

import ActivityTab from './ActivityTab'
import EngagementTab from './EngagementTab'

export interface ActivityTabsProps {}

const TAB_MAP = {
  feed: ActivityTab,
  engagement: EngagementTab
}

const Container = styled(Box, {})

const HeaderContainer = styled(Flex, {
  padding: '$4 $4 10px $4',
  height: '112px'
})

const TabHeader = styled(Header, {
  '&:hover': {
    cursor: 'pointer'
  },
  variants: {
    active: {
      true: {
        fontWeight: '$bold',
        textDecoration: 'underline',
        textUnderlineOffset: '16px',
        color: '$gray12'
      },
      false: {
        fontWeight: '$bold',
        textDecoration: 'none',
        color: '$gray8'
      }
    }
  }
})

const TabContainer = styled(Box, {
  padding: '0 $4 0 0',
  backgroundColor: '$gray2',
  height: 'calc(100vh - 112px)',
  width: '100%',
  overflowX: 'hidden'
})

const ActivityTabs = ({ access, sessionMetrics }: { access: any; sessionMetrics: any }) => {
  const { tab } = useParams() as { tab: 'feed' | 'engagement' }
  const Tab = TAB_MAP[tab] ?? ActivityTab
  const history = useHistory()

  const handleTabClick = (tab: 'feed' | 'engagement') => () => {
    history.push(`/activity/new/${tab}`)
  }
  return (
    <Container>
      <HeaderContainer direction="column">
        <Header variant="h1" gutterBottom="0">
          Prospector
        </Header>
        <Flex alignItems="center" gap={4}>
          <TabHeader
            gutterBottom="0"
            active={tab === 'engagement'}
            onClick={handleTabClick('engagement')}
            variant="h3">
            Account engagement
          </TabHeader>
          <TabHeader
            gutterBottom="0"
            active={tab === 'feed'}
            onClick={handleTabClick('feed')}
            variant="h3">
            All activity
          </TabHeader>
        </Flex>
      </HeaderContainer>
      <TabContainer>
        <Tab access={access} sessionMetrics={sessionMetrics} />
      </TabContainer>
    </Container>
  )
}

export default ActivityTabs
